import envConfig from '@nile/home/src/Config/env';

export const stateIconInfoMap = {
  approved: {
    icon: 'CircleTickOutlineMinor',
    color: '#48AC3D'
  },
  rejected: {
    icon: 'RejectedCircle',
    color: '#E72F23'
  },
  sent: {
    icon: 'WarningOutline',
    color: '#F07602'
  },
  needMoreInfo: {
    icon: 'WarningOutline',
    color: '#F07602'
  },
  cancelled: {
    icon: 'RejectedCircle',
    color: '#E72F23'
  }
};

export const lockaliseKeys = {
  approved: 'ticket.details.approvalBubble.approved',
  rejected: 'ticket.details.approvalBubble.rejected',
  sent: 'ticket.details.approvalBubble.sent',
  needMoreInfo: 'ticket.details.approvalBubble.needMoreInfo',
  cancelled: 'ticket.details.approvalBubble.cancelled'
};
